<div class="row">
  <new-folder [processing]="processing" (toggleCreateFolder)="create($event)" (toggleCancel)="cancel()"></new-folder>
</div>
